import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoCompleteModule, DropdownModule } from 'primeng';
import { SelectItem } from 'primeng/api';
import { VmeCommonModule } from '../../../vme-common.module';
import { OrderBookingHealthCheckService } from '../../../services/order-booking-health-check.service';

@Component({
  selector: 'order-booking-assigned-to',
  standalone: true,
  imports: [CommonModule, DropdownModule, AutoCompleteModule, VmeCommonModule],
  templateUrl: './order-booking-assigned-to.component.html',
})
export class BookingAssignedToComponent implements OnInit, OnChanges {
  @Input() assigneeId: string;
  @Input() assigneeName: string;
  @Output() assignedUserChange: EventEmitter<SelectItem> = new EventEmitter<SelectItem>();

  users: SelectItem[] = [];
  options: SelectItem[] = [];
  _assigneeId: string;

  constructor(private orderBookingHealthCheckService: OrderBookingHealthCheckService) {}

  async ngOnInit() {
    // Without the admin role the API returns only the current user, so the dropdown naturally
    // offers nothing but self-assignment.
    this.users = await this.orderBookingHealthCheckService.getAssignees();
    this._assigneeId = this.assigneeId;
    this.buildOptions();
  }

  ngOnChanges(changes: any) {
    if (changes.assigneeId) {
      this._assigneeId = changes.assigneeId.currentValue;
    }

    if (changes.assigneeId || changes.assigneeName) {
      this.buildOptions();
    }
  }

  // A non-admin is only offered themselves, so the current assignee is added to the options -
  // without it the dropdown shows its placeholder on a booking that is assigned.
  private buildOptions() {
    this.options =
      !this.assigneeId || this.users.some((x) => x.value === this.assigneeId)
        ? this.users
        : [{ value: this.assigneeId, label: this.assigneeName || 'Another user' }, ...this.users];
  }

  get assignee(): SelectItem {
    return {
      label: this.options.find((x) => x.value === this._assigneeId)?.label,
      value: this._assigneeId,
    };
  }

  unassignUser() {
    this.assignedUserChange.emit(null);
  }
}
